export class GetOCRRequestViewModel {
  public screeningID: number;
  public screeningNo: string;

}
export class GetOCRResponseViewModel {
  public iframeURL: string;

}
